import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class BigExplosion extends XYEffect {
	static key = "BigExplosion";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
	}
}
